/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "联系客服",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "icon_url",
                name: "图标",
                type: "small-img",
                memo: "建议尺寸：60px*60px"
            },
            {
                key: "name",
                name: "文案",
                type: "text",
                memo: "名称最多10个汉字",
                max: 10
            },
            {
                key: "contact_type",
                name: "联系方式",
                type: "customer-service"
            }
        ]
    }
];

export default config;